'use client';

import { useTranslations } from 'next-intl';
import { openCookieSettings } from '@/lib/cookie-consent';

/**
 * Re-opens the cookie-consent banner (detailed view, current choice
 * pre-filled). Rendered as a link-looking button in the footer's legal links
 * and on the cookies page — a permanent, standard place to change or withdraw
 * consent, per the EDPB cookie-banner taskforce report (no floating icon, so
 * nothing new competes with the fixed bottom bars).
 */
export function CookieSettingsLink({ className }: { className?: string }) {
  const t = useTranslations('common');
  return (
    <button type="button" onClick={openCookieSettings} className={className}>
      {t('cookieConsent.settingsLink')}
    </button>
  );
}
